import MDEditor from "@uiw/react-md-editor";
import React, { useEffect, useState } from "react";
import { updateRestaurantDetails } from "../../../util/getRestaurantInfo";

const RestaurantDescriptionEditor = ({ restaurantDetails, setAlert }) => {
  const [value, setValue] = useState("");

  useEffect(function syncValueFromRestaurantDetails() {
    if (restaurantDetails) {
      setValue(restaurantDetails.menu);
    }
  }, [restaurantDetails]);

  const handleSave = async () => {
    const updatedDetails = await updateRestaurantDetails(
      restaurantDetails.restaurantKey,
      { ...restaurantDetails, menu: value },
      setAlert
    );
    if (updatedDetails) {
      setAlert("Description saved successfully", "success");
    }
  };

  return (
    <div style={{ padding: "24px" }}>
      <div data-color-mode="light">
        <MDEditor value={value} onChange={setValue} height="200" />
      </div>
      <input
        className="btn btn-primary btn-sm"
        type="button"
        value="Save"
        onClick={handleSave}
        style={{ marginTop: "16px", padding: "8px 24px" }}
      />
    </div>
  );
};

export default RestaurantDescriptionEditor;
